import type {DatadogRum} from '@datadog/browser-rum'
import type {JSONValue} from '../../../common/schemas'

let browserRum: DatadogRum | null = null
const pendingFeatureFlags: {key: string; value?: JSONValue}[] = []

export const initBrowserRum = async () => {
  const applicationId = process.env.GATSBY_DD_APPLICATION_ID // eslint-disable-line no-process-env
  const clientToken = process.env.GATSBY_DD_CLIENT_TOKEN // eslint-disable-line no-process-env
  if (!applicationId || !clientToken) return

  const {datadogRum} = await import(/* webpackChunkName: "datadog" */ '@datadog/browser-rum')

  datadogRum.init({
    applicationId,
    clientToken,
    site: 'datadoghq.eu',
    service: 'web',
    // eslint-disable-next-line no-process-env
    env: process.env.GATSBY_DD_ENV || 'staging',
    sessionSampleRate: 100,
    // Disable session replays (#810).
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'allow',
    enableExperimentalFeatures: ['feature_flags'],
  })

  // Disable session replays (#810).
  // datadogRum.startSessionReplayRecording()

  browserRum = datadogRum

  let pendingFeatureFlag
  while ((pendingFeatureFlag = pendingFeatureFlags.pop())) {
    const {key, value} = pendingFeatureFlag
    browserRum.addFeatureFlagEvaluation(key, value ?? null)
  }
}

export const addFeatureFlag = (key: string, value?: JSONValue) => {
  if (browserRum) {
    browserRum.addFeatureFlagEvaluation(key, value ?? null)
  } else {
    pendingFeatureFlags.push({key, value})
  }
}
